

export default function Subheading({children}:any){

    return (<div style={{color:"var(--git-black",fontWeight:"bold" ,width:"100%",textAlign:"left",marginBottom:"4px"}} ><span  style={{ fontSize:"1em" }}>{children}</span></div>)
}